module.exports = __webpack_public_path__ + "img/EU.c118fa72.svg";